var map = {
	"./battery-level.svg": 5489,
	"./chip.svg": 6167,
	"./collect.svg": 897,
	"./entry.svg": 6715,
	"./home.svg": 8716,
	"./land.svg": 3942,
	"./mall.svg": 6919,
	"./member-center.svg": 2683,
	"./menu.svg": 8312,
	"./my.svg": 31,
	"./order.svg": 9235,
	"./other.svg": 4145,
	"./poultry.svg": 3528,
	"./reload.svg": 5562,
	"./setting.svg": 2647,
	"./share.svg": 5130,
	"./step-1.svg": 6921,
	"./step-2.svg": 4986,
	"./step-3.svg": 251,
	"./step-4.svg": 1892,
	"./together.svg": 8191,
	"./tree.svg": 1225,
	"./user-center.svg": 5178,
	"./user-my.svg": 9771,
	"./user-order.svg": 1927,
	"./user-other.svg": 4805,
	"./user-setting.svg": 4075,
	"./user.svg": 4692,
	"./user2.svg": 2286,
	"./user3.svg": 6015,
	"./welfare.svg": 1900
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8202;